export const cancelRequestedSelector = state =>
  state.bulkOutletUpdateExpiration.process.cancelRequested;
